import React from 'react';
import PropTypes from "prop-types";
import {useSelector} from "react-redux";
import Highcharts from "highcharts";
import HighchartsReact from 'highcharts-react-official';

const StudentSignups = function ({days}) {
    const dashboard_stats = useSelector(state => state.dashboard_stats);
    const students = dashboard_stats ? dashboard_stats.students : [];
    const compileData = function () {
        let data = [];
        if (students.length) {
            data.push({
                name: '#students',
                data: days.map(day => {
                    const student = students.find(student => student.created_at === day.toISOString().substring(0, 10));

                    return [
                        day.getTime(),
                        student ? student.count : 0
                    ];
                })
            });
        }

        return data;
    }

    return (
        <div>
            <HighchartsReact
                highcharts={Highcharts}
                options={{
                    chart: {
                        type: 'spline'
                    },
                    title: {
                        text: 'Student signups'
                    },
                    xAxis: {
                        title: {
                            text: 'Days'
                        },
                        type: 'datetime'
                    },
                    yAxis: {
                        title: {
                            text: '# students'
                        }
                    },
                    plotOptions: {
                        area: {
                            pointStart: 0,
                            marker: {
                                enabled: false,
                                symbol: 'circle',
                                radius: 2,
                                states: {
                                    hover: {
                                        enabled: true
                                    }
                                }
                            }
                        }
                    },
                    series: compileData(),
                    credits: {
                        enabled: false
                    },
                    accessibility: {
                        enabled: false
                    }
                }}
            />
        </div>
    );
}

StudentSignups.propTypes = {
    days: PropTypes.array.isRequired
};

export default StudentSignups;
